import ApiInfo from './ApiInfo.js'

const version = '/v1'

class CrowdApiInfo extends ApiInfo {
    constructor({
        path,
        type = 'get',
        timeout = 5000,
        headers,
        project = 'crowd', // || qukan,
        author = '未定义'
    }) {
        super({
            path,
            type,
            timeout,
            headers,
            project,
            author
        })
    }
}

export default {
    manage: {
        setTaskConfig: new CrowdApiInfo({
            // 修改配置,4.2
            path: version + '/task/config',
            type: 'post',
            author: '高国栋'
        }),
        setTaskRate: new CrowdApiInfo({
            // 修改任务质检比例,4.3
            path: version + '/task/rate',
            type: 'post',
            author: '高国栋'
        }),
        getAllData: new CrowdApiInfo({
            // 质检数据统计,4.4
            path: version + '/task/data',
            type: 'get',
            author: '张振胜'
        }),
        getSearchList: new CrowdApiInfo({
            // 质检结果搜索,4.5
            path: version + '/search',
            type: 'get',
            author: '孙万成'
        }),
        exportSearchList: new CrowdApiInfo({
            // 质检结果搜索,4.6
            path: version + '/exportSearch',
            type: 'get',
            author: '张振胜'
        }),
        getSubjectDetail: new CrowdApiInfo({
            // 查看质检结果详情,4.7
            path: version + '/subject/detail',
            type: 'get',
            author: '张振胜'
        }),
        getSubjectInfo: new CrowdApiInfo({
            // 运营质检,4.8
            path: version + '/subject/info',
            type: 'get',
            author: '张振胜'
        }),
        submitSubject: new CrowdApiInfo({
            // 提交质检结果,4.9
            path: version + '/subject/submit',
            type: 'post',
            author: '张振胜'
        }),
        getDataList: new CrowdApiInfo({
            // 众包打标签数据总览,4.10
            path: version + '/statisticsList',
            type: 'get',
            author: '孙万成'
        }),
        importData: new CrowdApiInfo({
            // 众包打标导出,4.11
            path: version + '/exportStatisticsList',
            type: 'get',
            author: '孙万成'
        }),
        getPaskList: new CrowdApiInfo({
            // 聚合任务列表,4.12
            path: version + '/p_task/list',
            type: 'get',
            author: '张振胜'
        }),
        getTaskList: new CrowdApiInfo({
            // 任务列表,4.13
            path: version + '/task/list',
            type: 'get',
            author: '张振胜'
        }),
        clearTaskList: new CrowdApiInfo({
            // 任务列表,4.13
            path: version + '/task/list',
            type: 'get',
            author: '张振胜'
        }),
        cleanTask: new CrowdApiInfo({
            // 清空队列,4.14
            path: version + '/task/clean',
            type: 'post',
            author: '张振胜'
        }),
        getTaskConfig: new CrowdApiInfo({
            // 查看任务配置,4.14
            path: version + '/task/show_config',
            type: 'get',
            author: '高国栋'
        })
    }
}



// WEBPACK FOOTER //
// ./src/core/Apis/Crowd.js